// We'll merge your dark mode toggle into the Navbar and ensure the hamburger icon shows only on mobile

import React, { useContext } from 'react';
import Logo from '../../Assets/Images/Logo.png';
import Linkedin from '../../Assets/Images/linkedin.png';
import Github from '../../Assets/Images/github.png';
import youtube from '../../Assets/Images/you2.png';
import Instagram from '../../Assets/Images/instagram.png';
import { Landingdata } from '../../Data/Landingdata';
import { ThemeContext } from '../Context/Context';

const Navbar = () => {
  const [click, setClick] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const { darkMode, setDarkMode } = useContext(ThemeContext);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleToggle = () => {
    setDarkMode(!darkMode);
  };

  return (
    <>
      <style>{`
        .modern-navbar {
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 100;
          transition: all 0.3s ease;
        }
        .navbar-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 1.5rem 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: ${darkMode ? 'rgba(12, 13, 11, 0.82)' : 'rgba(255, 255, 255, 0.82)'};
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-bottom: 1px solid ${darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(17, 17, 17, 0.1)'};
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        }
        .modern-navbar.scrolled .navbar-container {
          background: ${darkMode ? 'rgba(12, 13, 11, 0.58)' : 'rgba(255, 255, 255, 0.58)'};
          backdrop-filter: blur(28px) saturate(150%);
          -webkit-backdrop-filter: blur(28px) saturate(150%);
          box-shadow: 0 16px 44px ${darkMode ? 'rgba(0, 0, 0, 0.38)' : 'rgba(17, 17, 17, 0.1)'};
        }
        .logo-container {
          display: flex;
          align-items: center;
          cursor: pointer;
          transition: transform 0.3s ease;
          z-index: 101;
        }
        .logo-container:hover {
          transform: rotate(-5deg) scale(1.05);
        }
        .logo-img {
          width: 60px;
          height: auto;
          filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
        }
        .nav-menu {
          display: flex;
          list-style: none;
          align-items: center;
          gap: 2.5rem;
          margin: 0;
          padding: 0;
        }
        .nav-item {position: relative;}
        .nav-link {
          color: ${darkMode ? 'white' : '#1e293b'};
          text-decoration: none;
          font-size: 0.95rem;
          font-weight: 500;
          letter-spacing: 0.5px;
          padding: 0.5rem 0;
          transition: all 0.3s ease;
          display: inline-block;
          position: relative;
          text-shadow: ${darkMode ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 3px rgba(255,255,255,0.8)'};
        }
        .nav-link::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #f59e0b, #ef4444);
          transition: width 0.3s ease;
        }
        .nav-link:hover::after {width: 100%;}
        .nav-link:hover {color: ${darkMode ? '#fbbf24' : '#f59e0b'}; transform: translateY(-2px);}
        .social-links {
          display: flex;
          gap: 1rem;
          align-items: center;
          padding-left: 2rem;
          border-left: 1px solid ${darkMode ? 'rgba(46, 72, 149, 0.2)' : 'rgba(0, 0, 0, 0.2)'};
        }
        .social-icon {
          width: 22px;
          height: 22px;
          filter: ${darkMode ? 'brightness(0) invert(1)' : 'brightness(0) invert(0)'};
          opacity: 0.8;
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .social-icon:hover {
          opacity: 1;
          transform: rotate(10deg) scale(1.1);
          filter: ${darkMode ? 'brightness(0) invert(1) drop-shadow(0 0 8px rgba(251, 191, 36, 0.8))' : 'brightness(0) invert(0) drop-shadow(0 0 8px rgba(245, 158, 11, 0.8))'};
        }
        .mobile-menu-icon {
          display: none;
          font-size: 1.8rem;
          color: ${darkMode ? 'white' : '#1e293b'};
          cursor: pointer;
          z-index: 101;
          background: ${darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
          backdrop-filter: blur(10px);
          width: 45px;
          height: 45px;
          border-radius: 10px;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }
        .mobile-menu-icon:hover {
          background: ${darkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'};
          transform: scale(1.05);
        }
        .toggle-switch {
          width: 48px;
          height: 48px;
          background: ${darkMode ? 'rgba(200, 219, 66, 0.16)' : 'rgba(17, 17, 17, 0.06)'};
          backdrop-filter: blur(10px);
          border-radius: 999px;
          position: relative;
          cursor: pointer;
          border: 1px solid ${darkMode ? 'rgba(200, 219, 66, 0.4)' : 'rgba(17,17,17,0.14)'};
          margin-left:1rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: ${darkMode ? '#c8db42' : '#111111'};
          box-shadow: ${darkMode ? '0 10px 28px rgba(200, 219, 66, 0.14)' : '0 10px 28px rgba(17, 17, 17, 0.08)'};
        }
        .toggle-button {
          width: 28px;
          height: 28px;
          background: ${darkMode ? '#c8db42' : '#111111'};
          border-radius: 50%;
          position: relative;
          transition: transform 0.3s ease, background 0.3s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: ${darkMode ? '#111111' : '#ffffff'};
          font-size: 15px;
          line-height: 1;
        }
        .toggle-button.light,
        .toggle-button.dark {transform: none;}

        @media screen and (max-width: 1200px) {
          .mobile-menu-icon {display: flex;}
          .nav-menu {
            position: fixed;
            top: 0;left: -100%;
            width: 320px;height: 100vh;
            background: ${darkMode ? 'rgba(8, 8, 7, 0.96)' : 'rgba(251, 250, 246, 0.96)'};
            backdrop-filter: blur(24px) saturate(140%);
            -webkit-backdrop-filter: blur(24px) saturate(140%);
            border-right: 1px solid ${darkMode ? 'rgba(200, 219, 66, 0.18)' : 'rgba(17, 17, 17, 0.1)'};
            flex-direction: column;
            padding: 100px 2rem 2rem 2rem;
            gap: 1.5rem;
            align-items: flex-start;
            transition: left 0.4s;
            overflow-y:auto;
            box-shadow: 24px 0 60px ${darkMode ? 'rgba(0, 0, 0, 0.48)' : 'rgba(17, 17, 17, 0.12)'};
          }
          .nav-menu.active {left:0;}
          .nav-item {width:100%;padding:0.5rem 0;border-bottom:1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'};}
          .nav-link {font-size:1.1rem;display:block;width:100%;}
          .social-links {
            flex-direction: row;gap: 1.5rem;padding-left: 0;padding-top: 2rem;border-left: none;border-top:1px solid ${darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'};width:100%;justify-content:center;
          }
          .social-icon {width:28px;height:28px;}
        }
      `}</style>

      <nav className={`modern-navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="logo-container">
            <img src={Logo} alt="Logo" className="logo-img" decoding="async" />
          </div>

          <ul className={`nav-menu ${click ? 'active' : ''}`}>
            <li className="nav-item"><a href="#aboutsection" className="nav-link" onClick={Close}>About</a></li>
            <li className="nav-item"><a href="#skillsection" className="nav-link" onClick={Close}>Skills</a></li>
            <li className="nav-item"><a href="#projectsection" className="nav-link" onClick={Close}>Projects</a></li>
            <li className="nav-item"><a href="#experiencesection" className="nav-link" onClick={Close}>Experience</a></li>
            <li className="nav-item"><a href="#educationsection" className="nav-link" onClick={Close}>Education</a></li>
            <li className="nav-item"><a href="#achievementsection" className="nav-link" onClick={Close}>Achievements</a></li>
            <li className="nav-item"><a href="#contactsection" className="nav-link" onClick={Close}>Contact</a></li>
            <li className="social-links">
              <a href={Landingdata.linkedin} target="_blank" rel="noopener noreferrer"><img src={Linkedin} alt="LinkedIn" className="social-icon" /></a>
              <a href={Landingdata.github} target="_blank" rel="noopener noreferrer"><img src={Github} alt="GitHub" className="social-icon" /></a>
              <a href={Landingdata.insta} target="_blank" rel="noopener noreferrer"><img src={Instagram} alt="Instagram" className="social-icon" /></a>
              <a href={Landingdata.youtube} target="_blank" rel="noopener noreferrer"><img src={youtube} alt="YouTube" className="social-icon" /></a>
            </li>
          </ul>

          <button className="toggle-switch" onClick={handleToggle} aria-label="Toggle color theme">
            <div className={`toggle-button ${darkMode ? 'dark' : 'light'}`}>
              {darkMode ? '☾' : '☀'}
            </div>
          </button>

          <button className="mobile-menu-icon" onClick={handleClick} aria-label="Toggle navigation menu">
            {click ? '✕' : '☰'}
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;



